export default "__VITE_ASSET__Cc75D9h8__"